<template>
  <div class="fertilizer-application">
    <n-input-select
      name="fertilizer"
      class="product"
      :label="$t('product')"
      :options="fertilizers"
      :value="application.fertilizer"
      @change="handleValueChange"
      type="vertical" />
    <n-input-number
      name="rate"
      class="n-rate"
      :label="$t('n-rate')"
      unit="Kg/ha"
      min="0"
      :value="application.rate"
      @change="handleValueChange"
      type="vertical" />
    <div class="application-distribution" v-if="!fertigation">
      <div class="label">{{$t('distribution')}}</div>
      <div class="menu">
        <button
          @click="handleDistributionClick('one-time')"
          :class="{ 'selected': isDistributionSelected('one-time')}">
          {{$t('ui.one-time')}}
        </button>
        <button
          @click="handleDistributionClick('periodical')"
          :class="{ 'selected': isDistributionSelected('periodical')}">
          {{$t('ui.periodical')}}
        </button>
      </div>
    </div>
    <div class="input-distribution" v-if="isDistributionSelected('one-time')">
      <n-input-date
        name="date"
        :label="$t(fertigation ? 'application-until-date' : 'application-date')"
        :value="date"
        @change="handleValueChange" />
    </div>
    <div class="input-distribution" v-if="isDistributionSelected('periodical')">
      <n-input-date
        name="fromDate"
        class="date"
        :label="$t('from')"
        :value="fromDate"
        @change="handleValueChange" />
      <n-input-date
        name="toDate"
        class="date"
        :label="$t('to')"
        :value="toDate"
        @change="handleValueChange" />
      <n-input-number
        name="every"
        class="every"
        :label="$t('every')"
        :unit="$t('days')"
        min="0"
        type="vertical"
        :value="application.every"
        @change="handleValueChange" />
    </div>
    <!--
    <n-input-number
      label="BBCH"
      min="0"
      max="999"
      :value="application.bbch"
      type="vertical" /> -->
    <button class="button--remove-application" type="button" @click="$emit('remove')">
      <n-icon-base>
        <n-icon-delete />
      </n-icon-base>
    </button>
  </div>
</template>

<style lang="scss" scoped>

.button--remove-application {
  height: $spacing--l;
  width: $spacing--l;
  color: var(--color--secondary);
  padding: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  background-color: transparent;
  opacity: 0;
  margin-bottom: 0.125rem;
}

.fertilizer-application {
  @extend %form-row;
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  align-items: end;
  grid-gap: $spacing--xs;
}

.fertilizer-application:hover {
  .button--remove-application {
    opacity: 1;
    transition: 200ms ease-out;
  }
}

.product {
  width: 8rem;
}

.n-rate {
  width: 4rem;
}

.bbch {
  width: 2rem;
}

.date {
  width: 9rem;
}

.every {
  width: 4rem;
}

.application-distribution {
  .menu {
    display: flex;
    height: $spacing--l;
    align-items: center;
  }
  .label {
    @extend %text-style--label;
    font-size: var(--text--xs);
    color: var(--color--secondary);
    display: flex;
    align-items: center;
    height: $spacing--l;
  }
  button {
    font-size: var(--text--xs);
    white-space: nowrap;
    height: 2.5rem;
    padding: 0 $spacing--xs;
    background-color: transparent;
    border: 2px solid var(--color--outlines);
  }
  button:not(:first-child) {
    border-left: none;
  }
  button.selected {
    background-color: var(--color--action);
    border-color: var(--color--action);
    color: var(--color--white);
  }
}

.input-distribution {
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  align-items: end;
  grid-gap: $spacing--xs;
}

</style>

<script>
import moment from 'moment'

import InputSelect from '@/components/InputSelect'
import InputDate from '@/components/InputDate'
import InputNumber from '@/components/InputNumber'

import IconBase from '@/components/icons/IconBase'
import IconDelete from '@/components/icons/IconDelete'

export default {
  components: {
    'n-input-select': InputSelect,
    'n-input-date': InputDate,
    'n-input-number': InputNumber,
    'n-icon-base': IconBase,
    'n-icon-delete': IconDelete
  },
  props: {
    application: {
      type: Object
    },
    fertilizers: {
      type: Array
    },
    fertigation: {
      type: Boolean
    }
  },
  computed: {
    date () {
      return moment(this.application.date).format('YYYY-MM-DD')
    },
    fromDate () {
      return moment(this.application.fromDate).format('YYYY-MM-DD')
    },
    toDate () {
      return moment(this.application.toDate).format('YYYY-MM-DD')
    }
  },
  methods: {
    isDistributionSelected (mode) {
      return this.application.distribution === mode
    },
    handleDistributionClick (mode) {
      if (!this.isDistributionSelected(mode)) {
        this.$emit('change', {
          name: 'distribution',
          value: mode
        })
      }
    },
    handleValueChange (e) {
      const { name, type } = e.target
      let value = e.target.value
      if (type === 'date') {
        value = e.target.valueAsDate
      } else if (type === 'number') {
        value = e.target.valueAsNumber
      }
      this.$emit('change', {
        name,
        value
      })
    }
  }
}
</script>
